import { ReactNode } from 'react';
import classnames from 'classnames';
import { AircraftIcon, CarGroundIcon } from '@icons';
import { EdgeTransportInfoType } from '@lp/features/RoutePlanner/types';
import { TRANSPORT_PROVIDER_ABBR } from '@lp/features/RoutePlanner/utils';
import { RouteLegTypeEnum } from '@/api/apis/route';
import { GROUND_LEG_TYPES } from '@/utils/route';

type TransportLabelProps = {
  data: EdgeTransportInfoType;
  isRightDirection: boolean;
  label?: ReactNode;
};

export const TransportLabel = ({ data, isRightDirection, label }: TransportLabelProps) => {
  const isGround = GROUND_LEG_TYPES.includes(data.legType);
  const transportType = TRANSPORT_PROVIDER_ABBR[data.legType];
  const isCommercial = data.legType === RouteLegTypeEnum.CommercialFlightAviaLeg;
  const isAlt = label === 'alt';

  return (
    <div className="flex gap-1 items-center">
      {!isAlt && !isGround && !isCommercial && data.aircraft?.registration && (
        <span
          className={classnames('text-xs-sb text-base-20', {
            'order-1': isRightDirection,
            'order-2': !isRightDirection,
          })}
        >
          {data.aircraft.registration}
        </span>
      )}
      <div
        className={classnames('flex gap-1 items-center', {
          'order-1': !isRightDirection,
          'order-2': isRightDirection,
        })}
      >
        {!isAlt && !!data?.index && (
          <span
            className={classnames(
              'text-xs-m text-white w-3 h-3 flex justify-center items-center bg-black rounded-full',
              {
                'order-1': isRightDirection,
                'order-2': !isRightDirection,
              },
            )}
          >
            {data.index}
          </span>
        )}
        {!!transportType && (
          <span
            className={classnames(
              'px-1 py-0.5 text-xs-m text-white flex justify-center items-center bg-black rounded-full',
              {
                'order-1': isRightDirection,
                'order-2': !isRightDirection,
              },
            )}
          >
            {transportType}
          </span>
        )}
        <div
          className={classnames('text-base-5', {
            'order-2': !isRightDirection,
            'order-3': isRightDirection,
          })}
        >
          {isGround ? (
            <CarGroundIcon width={16} height={16} />
          ) : (
            <div className={classnames({ 'rotate-180': !isRightDirection })}>
              <AircraftIcon width={16} height={16} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
